export default "__VITE_ASSET__BuGO$Nez__"